import React from 'react'

const Footer = () => {
  return (
    <div className='bottom-0 w-full flex items-center justify-center bg-black'>
        <p className='text-white'>&copy;AJAY WALKE :&nbsp;</p>
        <p className='text-white'> Developed For Internship Project</p>
    </div>
  )
}

export default Footer
